import { ValidationErrorMessages } from '@constants/forms';
import { DirectDebitFormValues } from '@src/types/yourDetails';

import type { DirectDebitFormErrors } from '../types';

const sixDigitsRegex = /^\d{6}$/;
const eightDigitsRegex = /^\d{8}$/;

const validate = (values: DirectDebitFormValues) => {
  const errors: DirectDebitFormErrors = {};

  if (!values.ddName) {
    errors.ddName = ValidationErrorMessages.FIELD_REQUIRED;
  }

  if (!values.ddSortCode) {
    errors.ddSortCode = ValidationErrorMessages.FIELD_REQUIRED;
  } else if (!sixDigitsRegex.test(values.ddSortCode)) {
    errors.ddSortCode = ValidationErrorMessages.INVALID_SORT_CODE;
  }

  if (!values.ddAccountNumber) {
    errors.ddAccountNumber = ValidationErrorMessages.FIELD_REQUIRED;
  } else if (!eightDigitsRegex.test(values.ddAccountNumber)) {
    errors.ddAccountNumber = ValidationErrorMessages.INVALID_ACCOUNT_NUMBER;
  }

  return errors;
};

export { validate };
